import { useTranslation } from 'next-i18next'
// Dependencies
import React from 'react'
import styled, { css } from 'styled-components'

import { H2 } from './H2'
import { P } from './P'
import { Section } from './Section'
import { CTA } from './CTA'
import { Hyperlink } from './Hyperlink'
import { forScreensGreaterThanMobileWidth } from '../utils'
import { useAnalyticsEvent } from '../hooks/analyticsEvent'

// Props
interface Props {}

// Component
export const GetStarted: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // ..
  return (
    <Div>
      <Section>
        <div className="getStartedContainer">
          <H2>{t(`GetStarted-609946476`, `Get started and stay connected`)}</H2>
          <P>{t(`GetStarted-1392525172`, `All you need to do is sign up.`)}</P>
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <CreateNookCTA purpleBackground={true}>
              {t(`GetStarted-456944389`, `Create your Klyk profile`)}
            </CreateNookCTA>
          </div>
        </div>
      </Section>
    </Div>
  )
}

// Props.
interface CTAProps {
  className?: string
  purpleBackground: boolean
  children: any
}

// Log In CTA.
const CreateNookCTA: React.FC<CTAProps> = (props) => {
  const { children, className, purpleBackground } = props

  const analyticsEvent = useAnalyticsEvent()

  // ..
  return (
    <Hyperlink
      className={className}
      href="/signup"
      onClick={() => {
        analyticsEvent.signupLinkClicked('homepage-cta')
      }}>
      <CTA className={purpleBackground ? 'purple' : ''}>{children}</CTA>
    </Hyperlink>
  )
}

// Styled Components
const Div = styled.div`
  background-color: #fafafe;
  padding: 60px 20px;

  .getStartedContainer {
    align-items: center;
    background-image: url(/images/getStartedBg.png);
    background-size: cover;
    border-radius: 16px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    padding: 130px 20px 170px 20px;
    text-align: center;
    width: 100%;

    h2 {
      color: #fff;
    }

    p {
      color: #fff;
    }

    /* Desktop. */
    ${forScreensGreaterThanMobileWidth(css`
      width: 82%;
    `)}
  }
`
